@if (showContainer) {
  <div class="assign-bottom-action-container" [@slideInOut] [ngClass]="isBottomScrolled ? 'scrolled' : ''">
    <div class="action-subject">
      <div class="action-subject__item action-subject-text">
        <div>
          <span>{{ selected?.length }} </span>
          {{ selected?.length > 1 ? 'orders' : 'order' }}
          selected
        </div>
        @if (errors.length) {
          <div class="small-text">
            @for (error of errors; track error) {
              <div class="error">*{{ error }}</div>
            }
          </div>
        }
        @if (isOrdersUpdating) {
          <div class="small-text">Please wait for orders to finish updating</div>
        }
      </div>
      <div class="action-subject__item action-subject-button">
        <pdq-button
          label="Batch & assign"
          variant="primary"
          [disabled]="isAssignBtnDisabled || isOrdersUpdating"
          [matTooltip]="''"
          (onClick)="openDialog()">
        </pdq-button>
      </div>
    </div>
  </div>
}
